exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title-device-name {\n  font-family: PingFangSC-Regular;\n  font-size: 16px;\n  color: rgba(0, 0, 0, 0.85); }\n\n.title-device-info {\n  font-family: PingFangSC-Regular;\n  font-size: 14px;\n  color: rgba(0, 0, 0, 0.65);\n  line-height: 22px;\n  margin-top: 16px; }\n  .title-device-info span {\n    margin-right: 40px; }\n", ""]);

// exports
